import ServiceHistoryRow from '../ServiceHistoryRow';

import { VerticalContainer, Wrapper } from '@american-autonomy/ag-ui';

import EmptyState from 'components/EmptyState';

import useTranslation from 'pages/MaintenancePage/hooks/useTranslation';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const ServiceHistoryList: FunctionComponent<Props> = ({
    className = '',
    isAdmin,
    onSelectRecord,
    onVoidRecord,
    records,
    testId = TEST_ID
}) => {
    const t = useTranslation();
    // Newest-first by service date, not log date — backdated work sorts where it happened.
    const sortedRecords = [...records].sort(
        (first, second) =>
            new Date(second.performedAt).getTime() - new Date(first.performedAt).getTime()
    );

    return (
        <VerticalContainer className={`${styles.serviceHistoryList} ${className}`} testId={testId}>
            <Wrapper className={styles.heading}>{t.SERVICE_HISTORY_HEADING}</Wrapper>

            {sortedRecords.length === 0 && <EmptyState text={t.SERVICE_HISTORY_EMPTY} />}

            {sortedRecords.map(record => (
                <ServiceHistoryRow
                    isAdmin={isAdmin}
                    key={record.id}
                    onSelectRecord={onSelectRecord}
                    onVoidRecord={onVoidRecord}
                    record={record}
                />
            ))}
        </VerticalContainer>
    );
};

export default ServiceHistoryList;
